import { Button } from '../../cdl/Button/Button';
import { StatePlaceholder } from '../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../common/helpers/translate.helper';
import { IconAlertTriangle } from '../../common/icons/cdl/AlertTriangle';
import { Box } from '../../common/ui/Box';

import { DemandFlowStatusOverlay } from './DemandFlowStatusOverlay';

interface DemandCalculationErrorOverlayProps {
    canSaveDraft: boolean;
    isRetrying: boolean;
    onRetry: () => void;
    onSaveDraft: () => void;
    onKeepEditing: () => void;
    onClose: () => void;
}

export const DemandCalculationErrorOverlay = ({
    canSaveDraft,
    isRetrying,
    onRetry,
    onSaveDraft,
    onKeepEditing,
    onClose,
}: DemandCalculationErrorOverlayProps) => (
    <DemandFlowStatusOverlay>
        <Box width="100%" maxWidth="420px">
            <StatePlaceholder
                title={translate('demandDefinition.calculationFailedTechnicalTitle')}
                description={translate(
                    canSaveDraft
                        ? 'demandDefinition.calculationFailedSaveableDescription'
                        : 'demandDefinition.calculationFailedUnsavableDescription'
                )}
                Icon={IconAlertTriangle}
                action={
                    <Box display="flex" flexWrap="wrap" gap={8}>
                        {canSaveDraft ? (
                            <Button emphasis="high" onClick={onSaveDraft} disabled={isRetrying}>
                                {translate('demandDefinition.saveAsDraft')}
                            </Button>
                        ) : null}
                        <Button onClick={onRetry} isLoading={isRetrying}>
                            {translate('demandDefinition.retryCalculation')}
                        </Button>
                        <Button emphasis="low" onClick={onKeepEditing} disabled={isRetrying}>
                            {translate('drawer.keepEditing')}
                        </Button>
                        <Button emphasis="low" onClick={onClose} disabled={isRetrying}>
                            {translate('global.close')}
                        </Button>
                    </Box>
                }
            />
        </Box>
    </DemandFlowStatusOverlay>
);
